import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import axios from "axios";

ChartJS.register(ArcElement, Tooltip, Legend);

const Hero = () => {
  const [supplyData, setSupplyData] = useState(null);

  useEffect(() => {
    const fetchSupplyData = async () => {
      try {
        const response = await axios.get("https://explorer.menelik.cc:3300/api/supply");
        setSupplyData(response.data);
      } catch (error) {
        console.error("Error fetching supply data:", error);
      }
    };
    fetchSupplyData();
  }, []);

  const supplyChartData = supplyData
    ? {
        labels: ["Burnt", "Circulating Supply", "Locked Supply", "Developer Coins"],
        datasets: [
          {
            data: [
              supplyData.burntCoins,
              parseFloat(supplyData.circulatingSupply),
              supplyData.maximumSupply - supplyData.totalEmitted,
              supplyData.developerCoins,
            ],
            backgroundColor: ["#FF4500", "#FFD700", "#808080", "#4169E1"],
            hoverBackgroundColor: ["#FF6347", "#FFEC8B", "#A9A9A9", "#1E90FF"],
          },
        ],
      }
    : null;

  return (
    <section className="bg-[url('https://images.unsplash.com/photo-1661961112959-3f8a98f859b4')] bg-cover bg-center text-white h-auto flex flex-col items-center justify-center py-16">
      <motion.div
        className="p-8 max-w-3xl text-center bg-black bg-opacity-50 rounded-xl backdrop-blur-md shadow-lg"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <h1 className="text-4xl font-bold mb-4">Welcome to MenelikCoin</h1>
        <p className="text-lg">
          MENEL: The Ultimate Cross-Chain Solution Powered by Smartnodes
          MENEL is the all-in-one solution for gaming, staking, and mining, providing a robust and highly efficient infrastructure. Its ecosystem integrates advanced mechanisms such as
          <span className="text-yellow-400 font-semibold"> coin burning and supply locking,</span> optimizing network stability and sustainability.
          Additionally, MENEL rewards Smartnodes, which play a key role in its operation, and features publicly controlled fund addresses allocated for
          <span className="text-yellow-400 font-semibold"> developers, incentives, airdrops, donations, and more</span>, along with rewards for Smartnodes.
          , ensuring transparency and continuous growth.
        </p>
        <a
          href="#about"
          className="inline-block mt-6 px-6 py-3 bg-indigo-600 hover:bg-indigo-800 rounded-md font-semibold"
        >
          Learn More
        </a>
      </motion.div>

      {supplyData && (
        <motion.div
          className="mt-10 max-w-5xl grid grid-cols-1 md:grid-cols-2 gap-8 bg-black bg-opacity-50 p-6 rounded-lg shadow-lg backdrop-blur-md border-l-4 border-yellow-400"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="text-center p-4 border-r md:border-r-2 border-gray-600">
            <h2 className="text-2xl font-bold text-yellow-400 mb-4">Supply Details</h2>
            <p className="text-gray-300">
              <span className="font-semibold text-green-400 text-lg">Circulating Supply:</span>{" "}
              {parseFloat(supplyData.circulatingSupply).toLocaleString()}
            </p>
            <p className="text-gray-300">
              <span className="font-semibold text-yellow-400">Emitted:</span> {supplyData.totalEmitted.toLocaleString()}
            </p>
            <p className="text-gray-300">
              <span className="font-semibold text-red-500">Burnt:</span> {supplyData.burntCoins.toLocaleString()}
            </p>
            <p className="text-gray-300">
              <span className="font-semibold text-red-500">Total Supply:</span> {supplyData.maximumSupply.toLocaleString()}
            </p>

            <p className="text-gray-300">
              <span className="font-semibold text-indigo-400 text-lg">Developer Coins:</span>{" "}
              {supplyData.developerCoins.toLocaleString()}
            </p>
            <p className="text-gray-300">
              <span className="font-semibold text-blue-400 text-lg">Locked Supply (Not Emitted):</span>{" "}
              {(supplyData.maximumSupply - supplyData.totalEmitted).toLocaleString()}
            </p>

          </div>

          <div className="text-center p-4 flex flex-col items-center">
            <h3 className="text-2xl font-semibold text-yellow-400 mb-4">Supply Distribution</h3>
            {supplyChartData && (
              <div className="w-40 h-40">
                <Pie data={supplyChartData} />
              </div>
            )}
          </div>
        </motion.div>
      )}
    </section>
  );
};

export default Hero;
